/**
 * Gezinme sürerken sayfanın üstünde ince ilerleme çubuğu (owner 2026-10-04).
 *
 * React Router 7 gezinmeyi geçiş içinde yapar; yeni sayfa hazır olana kadar
 * eski sayfa ekranda kalır (bkz. utils/lazyWithPreload). Kullanıcı "tıkladım,
 * bir şey olmadı" sanmasın diye: gezinme başlarken `startNavigationProgress()`
 * çağrılır, render edilen konum değişince çubuk kalkar. 8 saniyede kendiliğinden
 * kalkar (takılı kalmasın).
 */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './NavigationProgress.scss';

const EVENT = 'app-navigation-start';

/** Aynı sayfaya gezinmede çubuk açılmaz (konum değişmeyeceği için kalkmazdı). */
export const startNavigationProgress = (route?: string): void => {
  const here = window.location.pathname + window.location.search;
  if (route && route === here) return;
  window.dispatchEvent(new Event(EVENT));
};

const NavigationProgress: React.FC = () => {
  const location = useLocation();
  const [active, setActive] = useState(false);

  useEffect(() => {
    const on = () => setActive(true);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);

  // Render edilen konum değişti: yeni sayfa ekranda.
  useEffect(() => {
    setActive(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!active) return undefined;
    const id = window.setTimeout(() => setActive(false), 8000);
    return () => window.clearTimeout(id);
  }, [active]);

  if (!active) return null;
  return (
    <div className="nav-progress" role="progressbar" aria-busy="true">
      <div className="nav-progress__bar" />
    </div>
  );
};

export default NavigationProgress;
